import {Injectable} from '@angular/core';
import {Capacitor, registerPlugin} from "@capacitor/core";
import {BackgroundGeolocationPlugin, Location} from "@capacitor-community/background-geolocation";
import '@turf/simplify'
import {StatusGPS} from "./StatusGPS";
import {LineString} from "typeorm/browser";
import {Geolocation} from "@capacitor/geolocation";
import {AlertController} from "@ionic/angular";

@Injectable({providedIn: 'root'})
export class GpsService {
  private BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");
  private watcher: any
  tracking: Location[] = []
  private CHAVE_PONTOS="tracking"
  private CHAVE_STATUS="status_tracking"
  private listeners = []
  private messageAndroid = `
          O app Fauna coleta sua localização em segundo plano para registrar tracking mesmo com o app fechado e a tela desligada.
          Se concorda clique em Configurar e depois escolha Permissões, Localização e por fim "Permitir o tempo todo".`

  private messageIphone = `
          O app Fauna coleta sua localização em segundo plano para registrar tracking mesmo com o app fechado e a tela desligada.
          Se concorda clique em Configurar e depois escolha Localização e por fim "Sempre".`
  addListener(l){
    this.listeners.push(l)
  }

  constructor(private alertController: AlertController) {
  }

  get lineString(): LineString {
    return {
      type: "LineString",
      coordinates: this.tracking.map(p => [p.longitude, p.latitude])
    }
  }

  continuar() {
      const status = localStorage.getItem(this.CHAVE_STATUS)
      if(status == StatusGPS.ATIVO) {
        console.log('iniciando gps')
        this.tracking = JSON.parse(localStorage.getItem(this.CHAVE_PONTOS))||[]
        this.iniciar().then()
      } else{
        console.log('nenhum tracking em andamento')
      }
  }

  async iniciar(){
    console.log("Iniciando coleta de coordenadas")
    this.watcher = await this.BackgroundGeolocation.addWatcher(this.options,
      (location, error) => {
      // alert(error?.code)
        if (error?.code === "NOT_AUTHORIZED") {
          this.exibirConfig().then()
        } else {
          this.registrar(location)
        }
      })
    localStorage.setItem(this.CHAVE_STATUS,StatusGPS.ATIVO)
    console.log('watcher registrado', this.watcher)
  }

  private async  exibirConfig() {
    const message = Capacitor.getPlatform() == "android" ?  this.messageAndroid : this.messageIphone
    const alerta = await this.alertController.create({
      header: 'Permissão de Localização',
      message: message,
      buttons: [
        {text: 'Cancelar'},
        {
          text: 'Configurar',
          handler: () => {
            this.BackgroundGeolocation.openSettings().then();
          },
        },
      ]
    });
    alerta.present().then()
  }



  private registrar(position: Location) {
    this.tracking.push(position)
    this.listeners.forEach(i=> i.receberPonto())
    localStorage.setItem(this.CHAVE_PONTOS, JSON.stringify(this.tracking))
    console.log('pontos', this.tracking)
    // if(this.tracking.length > 1) {
    //   const original = this.getLineString()
    //   const simpl = simplify(original, {tolerance: 0.001, highQuality: true})
    //   console.log("original", original)
    //   console.log("simplificado turf", simpl)
    // }
  }

  async parar(){
    await this.pausar()
    localStorage.setItem(this.CHAVE_STATUS, StatusGPS.PARADO)
    this.tracking = []
  }

  async pausar(){
    try {
      localStorage.setItem(this.CHAVE_STATUS, StatusGPS.PAUSADO)
      console.log('removendo watcher', this.watcher)
      await this.BackgroundGeolocation.removeWatcher({id: this.watcher})
    } catch (e) {
      console.error(e)
    }
  }

  private options = {
    // If the "backgroundMessage" option is defined, the watcher will
    // provide location updates whether the app is in the background or the
    // foreground. If it is not defined, location updates are only
    // guaranteed in the foreground. This is true on both platforms.

    // On Android, a notification must be shown to continue receiving
    // location updates in the background. This option specifies the text of
    // that notification.
    backgroundMessage: "Cancel to prevent battery drain.",

    // The title of the notification mentioned above. Defaults to "Using
    // your location".
    backgroundTitle: "Tracking You.",

    // Whether permissions should be requested from the user automatically,
    // if they are not already granted. Defaults to "true".
    requestPermissions: false, // Capacitor.getPlatform() == "ios",

    // If "true", stale locations may be delivered while the device
    // obtains a GPS fix. You are responsible for checking the "time"
    // property. If "false", locations are guaranteed to be up to date.
    // Defaults to "false".
    stale: false,

    // The minimum number of metres between subsequent locations. Defaults
    // to 0.
    distanceFilter: 3

  }

}


